import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { SectionSplitProps } from "../../utils/SectionProps";
import SectionHeader from "./partials/SectionHeader";
import Image from "../elements/Image";
import "react-phone-number-input/style.css";
import { useRef } from "react";
import emailjs, { init } from "@emailjs/browser";
import {
  ToastContainer,
  toast,
  Bounce,
} from "react-toastify/dist/react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { db } from "../../firebase/config";
import { doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";

init("fCfC7W2RdA4AhvbaZ");

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    "features-split section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "features-split-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const splitClasses = classNames(
    "split-wrap",
    invertMobile && "invert-mobile",
    invertDesktop && "invert-desktop",
    alignTop && "align-top"
  );

  const sectionHeader = {
    title: "Why trust us?",
    paragraph:
      "Our extreme risk calculations have developed over 30 years such that we know what is safe and can provide high returns and earn good profits. ",
  };

  const sectionHeader1 = {
    title: "Join us and Get Started!",
    paragraph: "",
  };

  const [inputs, setInputs] = useState({});

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const form = document.getElementById("contactUsForm");

  const handleSubmit = async (event) => {
    event.preventDefault();
    inputs.textAreaQuery =
      inputs.textAreaQuery != undefined
        ? inputs.textAreaQuery
        : "I want to connect with you.";
    const serviceID = "service_5iglwvo";
    const templateID = "template_95hnikr";

    const docRef = doc(db, "userRequests", inputs.phoneNumber);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      console.log("Existing user");
      toast.info(
        "Thank you for being so eager to connect with us. We've already received your request and we'll reach out to you shortly. If you think there is a delay in us connecting with you, send us an email or maybe enquire with another mobile number.",
        {
          autoClose: 10000,
          draggablePercent: 60,
          transition: Bounce,
        }
      );
    } else {
      console.log("No such document!");
      console.log("New user");
      await setDoc(doc(db, "userRequests", inputs.phoneNumber), {
        name: inputs.name,
        phoneNumber: inputs.phoneNumber,
        email: inputs.email,
        query: inputs.textAreaQuery,
        isAttended: false,
      });
      emailjs.sendForm(serviceID, templateID, form, this).then(
        (result) => {
          toast.success(
            "We've received your request to connect with us. We'll connect with you shortly on the email or mobile number provided.",
            {
              autoClose: 8000,
              draggablePercent: 60,
              transition: Bounce,
            }
          );
          console.log(result.text);
        },
        (error) => {
          toast.error(
            "There was some error sending email to the email-id you've provided. If this keeps happening frequently, reach out to us on email.",
            {
              autoClose: 3000,
              draggablePercent: 60,
              transition: Bounce,
            }
          );
          console.log(error.text);
        }
      );
    }

    setInputs((values) => ({}));
  };
  const contactUs = useRef(null);

  return (
    <section ref={contactUs} {...props} className={outerClasses}>
      <div className="container contactUs">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <SectionHeader data={sectionHeader1} className="center-content" />
          <div className={splitClasses}>
            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8 ">
                  Step 1
                </div>
                <h3 className="mt-0 mb-12">Reach out to us</h3>
                <p className="m-0">
                  You can reach out to us by filling the contact details. We
                  will reach out to you at a convenient time.
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <form id="contactUsForm" name="contactUsForm">
                  <div className="mb-3 pt-0 m-12">
                    <input
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter your name"
                      name="name"
                      value={inputs.name || ""}
                      className="text p-24 input-curved-border form-input form-input-sm px-3 py-3 placeholder-gray-400 text-gray-600 relative bg-white bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                      required
                    />
                  </div>
                  <div className="mb-3 pt-0 m-12">
                    <input
                      onChange={handleChange}
                      type="email"
                      placeholder="Enter your Email Id"
                      name="email"
                      value={inputs.email || ""}
                      className="text p-24 input-curved-border form-input form-input-sm px-3 py-3 placeholder-gray-400 text-gray-600 relative bg-white bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
                      required
                    />
                  </div>
                  <div className="row mb-3 pt-0 m-12 col-sm-4">
                    <input
                      className="text p-24 input-curved-border-half form-input form-input-sm"
                      type="number"
                      id="phone"
                      name="phoneNumber"
                      pattern="+91[7-9]{5}-[0-9]{5}"
                      placeholder="Mobile number without +91"
                      minLength="10"
                      maxLength="12"
                      onChange={handleChange}
                      onWheel={() => document.activeElement.blur()}
                      value={inputs.phoneNumber || ""}
                      required
                    />
                  </div>
                  <div className="mb-3 pt-0 m-12">
                    <textarea
                      type="input form-input textarea"
                      className="text p-24 input-curved-border-textarea form-input form-input-sm"
                      placeholder="Your query here...you may leave it blank"
                      name="textAreaQuery"
                      onChange={handleChange}
                      value={inputs.textAreaQuery || ""}
                      required
                    />
                  </div>
                  <div className="mb-3 pt-0 m-12">
                    <button
                      className="button curved-border button-primary bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      onClick={handleSubmit}
                    >
                      Get in touch
                    </button>
                    <ToastContainer />
                  </div>
                </form>
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Step 2
                </div>
                <h3 className="mt-0 mb-12">We'll get you onboarded</h3>
                <p className="m-0">
                  We'll need to perform your KYC before onboarding you post
                  which we'll provide you your credentails to login to our
                  portal and you can start investing.
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/fingerprint.png")}
                  alt="Features split 02"
                  width={528}
                  height={396}
                />
              </div>
            </div>

            <div className="split-item">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Step 3
                </div>
                <h3 className="mt-0 mb-12">Invest and get returns</h3>
                <p className="m-0">
                  You can invest with us on a project basis and earn better
                  Returns on your Investments
                </p>
              </div>
              <div
                className={classNames(
                  "split-item-image center-content-mobile reveal-from-bottom",
                  imageFill && "split-item-image-fill"
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require("./../../assets/images/coin-plant-growth-blur2.png")}
                  alt="Features split 03"
                  width={450}
                  height={350}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
